import {
  ValidatedInput,
  ValidationMessage,
  FormLabel
} from "../../shared/components";
import vSelect from 'vue-select'

export default {
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    categories: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    'v-select': vSelect
  },
  mounted() {
    this.model.categoryId = this.categoryId
  },
  data() {
    return {
      model: {
        categoryId: this.categoryId
      }
    };
  },
  computed: {
    localizedCategoryName() {
      return this.$i18n.locale.startsWith('fr') ? "nameFr" : "nameEn";
    },
    category: {
      get() {
        if (this.model.categoryId === null) return this.categories.find(x => x.id === this.categoryId);
        return this.categories.find(x => x.id === this.model.categoryId);
      },
      set(val) {
        this.model.categoryId = val.id;
        this.$emit('onCategoryChanged', val);
      }
    }
  },
  emits: ['onCategoryChanged']
};
